import { LegalLayout, LegalSection } from "@/components/LegalLayout";

export default function PrivacyPolicy() {
  return (
    <LegalLayout title="Privacy Policy" updated="July 3, 2026" testid="privacy-page">
      <p>
        This Privacy Policy explains what information Learn Me collects, how we use it, and the choices
        you have. We designed Learn Me to respect your data.
      </p>

      <LegalSection heading="1. Information we collect" testid="privacy-collect">
        <p>
          We collect the information you provide when you create an account (name, email, password),
          the topics and courses you generate, and basic usage data needed to operate the service.
        </p>
      </LegalSection>

      <LegalSection heading="2. Personalpedia & Personal FAQ data" testid="privacy-personalpedia">
        <p>
          Your <strong>Personalpedia</strong> knowledge base and <strong>Personal FAQ</strong> are built
          from the courses you generate and the questions you ask. We store this data securely and use
          it solely to power your personal learning features — for example, answering your questions
          from your own library and generating recommendations for you.
        </p>
        <p>
          This data is tied to your account and is visible only to you (and, where applicable, to
          administrators for support and safety purposes).
        </p>
      </LegalSection>

      <LegalSection heading="3. We do not sell or share your data for AI training without consent" testid="privacy-no-sharing">
        <p>
          <strong>Your personal data and generated content are never shared with third parties for
          their AI model training without your explicit consent.</strong> We do not sell your personal
          information. We use trusted service providers only to operate Learn Me (see below).
        </p>
      </LegalSection>

      <LegalSection heading="4. Payment processing (Stripe)" testid="privacy-stripe">
        <p>
          Payments are handled by <strong>Stripe</strong>, our secure, PCI-compliant payment processor.
          Your card details are provided directly to Stripe and are <strong>never stored on Learn Me's
          servers</strong>. We retain only the minimal transaction records needed for accounting and
          support.
        </p>
      </LegalSection>

      <LegalSection heading="5. AI service providers" testid="privacy-ai-providers">
        <p>
          To generate courses and narration, topics you submit are processed by our AI providers strictly
          to deliver the requested output. We do not authorize them to use your content to train their
          models without your consent.
        </p>
      </LegalSection>

      <LegalSection heading="6. Data retention and your rights" testid="privacy-rights">
        <p>
          We keep your data for as long as your account is active. You can delete individual courses at
          any time, and you may request deletion of your account and associated data through the Support
          page.
        </p>
      </LegalSection>

      <LegalSection heading="7. Changes to this policy" testid="privacy-changes">
        <p>
          We may update this Privacy Policy from time to time. Material changes will be reflected in the
          "Last updated" date above.
        </p>
      </LegalSection>

      <LegalSection heading="8. Contact" testid="privacy-contact">
        <p>Questions about your privacy? Reach us through the in-app Support page.</p>
      </LegalSection>
    </LegalLayout>
  );
}
